const $win = $(window);
const $doc = $(document);

$doc.on('click', '.js-tab-link', function(e){
  e.preventDefault();

  const $this = $(this);
  const $target = $(this.hash);
  const $slider = $target.find('.js-slider .slider__slides');

  $target.closest('.js-tabs').find('.js-tab-link').removeClass('is-active');
  $target.closest('.js-tabs').find('.js-tab').removeClass('is-active').hide();

  $this.addClass('is-active');
  $target.closest('.js-tabs').find('.js-tab-link[href="' + this.hash + '"]').addClass('is-active');

  $target.addClass('is-active').show();

  // if ($target.length) {
  //   $('html, body').animate({ scrollTop: $target.offset().top - $('.header').outerHeight() - $('.js-bar').outerHeight() - 80 }, 1000);
  // }

  if ($slider && $slider.length && !$slider.hasClass('loaded')) {
    $slider.slick('refresh');
    $slider.addClass('loaded');

    return;
  }

  $slider.slick('resize');
});